import { logger } from "@/lib/logger";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { performCompleteLogout } from "@/lib/auth-utils";
import { Skeleton } from "@/components/ui/skeleton";
import { Helmet } from "react-helmet-async";

export default function Logout() {
  const navigate = useNavigate();

  useEffect(() => {
    const handleLogout = async () => {
      logger.debug("🚪 Emergency logout initiated");
      const result = await performCompleteLogout();
      
      if (result.success) {
        logger.debug("✅ Emergency logout successful");
        // The performCompleteLogout already handles redirect
      } else {
        logger.error("❌ Emergency logout failed:", result.error);
        // Force redirect anyway
        window.location.replace('/auth');
      }
    };

    handleLogout();
  }, [navigate]);

  return (
    <>
      <Helmet>
        <title>Logging Out - PharmaTrialConnect</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      
      <div className="min-h-screen bg-background flex items-center justify-center p-4">
        <div className="space-y-4 w-full max-w-md text-center">
          <h1 className="text-2xl font-semibold">Logging you out...</h1>
          <Skeleton className="h-12 w-full" />
          <p className="text-sm text-muted-foreground">
            Clearing your session and redirecting to login
          </p>
        </div>
      </div>
    </>
  );
}
